module.exports = __webpack_public_path__ + "d292ae0e0c1b3f1d059ebf31c0639429.png";